import { IBaseModel } from '../../shared/interfaces/IBaseModel';
import { IPagination } from '../../shared/interfaces/IPagination';
import { ITrailer } from '../../shared/interfaces/ITrailer';
import { requests } from '../../utils/api/api.service';
import { TRAILER_URL } from '../../utils/api/endpoints';

export const AdminTrailerService = {
  getAll: (data: IPagination): Promise<IBaseModel<ITrailer[]>> =>
    requests.get(TRAILER_URL, data),
  create: (data: ITrailer): Promise<ITrailer> =>
    requests.post(TRAILER_URL, data),
  update: (data: ITrailer): Promise<ITrailer> =>
    requests.put(`${TRAILER_URL}/${data?.id}`, data),
  delete: (id: number) => requests.delete(`${TRAILER_URL}/${id}`),
};
